import type { ReactNode } from "react";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import LabelDialog from "~/components/label/label-dialog";
import { LabelContext } from "~/hooks/use-label";
import { api } from "~/lib/api";
import { useLoadingStore } from "~/stores/use-loading-store";
import { UnsavedChangesProvider } from "./unsaved-changes-provider";
import { RouterOutputs } from "@repo/api";

export type Label = RouterOutputs["label"]["getAll"][number];

interface LabelProviderProps {
  children: ReactNode;
}

export function LabelProvider({ children }: LabelProviderProps) {
  const { data: labels, isFetching: isLabelsLoading } =
    api.label.getAll.useQuery(undefined, {
      initialData: [],
    });

  const { setLoadingStage } = useLoadingStore(
    useShallow((state) => ({
      setLoadingStage: state.setCurrentLoadingStage,
    })),
  );

  useEffect(() => {
    if (isLabelsLoading) {
      setLoadingStage("labels");
    } else {
      setLoadingStage(undefined);
    }
  }, [isLabelsLoading, setLoadingStage]);

  const context = {
    labels,
  };

  return (
    <LabelContext.Provider value={context}>
      <UnsavedChangesProvider>
        <LabelDialog />
      </UnsavedChangesProvider>
      {children}
    </LabelContext.Provider>
  );
}
